import React, { useState, useEffect, useContext } from 'react';
import { Button, Dropdown, Icon, Popup } from 'semantic-ui-react';
import ModalBox from '../../components/templates/components/ModalBox';
import APIResponse from '../../components/templates/components/APIResponse';
import AppointmentService from '../api/appointment.service';
import { store } from '../../context/StateProvider';
import EditAppointmentForm from '../../components/secure/provider/appointment/edit-appointment-form/EditAppointmentForm';
import ChartNotes from '../../components/secure/provider/appointment/charting/ChartNotes';
import AppointmentNotify from '../../components/secure/provider/appointment/appointment-notify/AppointmentNotify';
import AddAppointmentForm from '../../components/secure/provider/appointment/add-appointment-form/AddAppointmentForm'
import AppointmentStatus from '../../components/secure/provider/appointment/appointment-status/AppointmentStatus';
import EditInvoice from '../../components/secure/provider/invoices/edit-invoice/EditInvoice';
import AddInvoice from '../../components/secure/provider/invoices/add-invoice/AddInvoice';
import DimLoader from '../../components/templates/components/DimLoader';
import './ButtonGroup.scss'
const AppointmentButtonGroup = (props) => {
  const state = useContext(store).state
  const [appointmentData, setAppointmentData] = useState(props.initialData || {})
  const [chartNotes, setChartNotes] = useState(false)
  const [deleteView, setDeleteView] = useState(false)
  const [notifyView, setNotifyView] = useState(false)
  const [reason, setReason] = useState("")
  const [cancelType, setCancelType] = useState(1)
  const [showAdd, setShowAdd] = useState(false)
  const [editAppt, setEditAppt] = useState(false)
  const [checkOutInvoice, setCheckOutInvoice] = useState(null)

  const [statusView, setStatusView] = useState(false)
  const [showEditInvoice, setShowEditInvoice] = useState(false)
  const [dropdownItems, setDropdownItems] = useState([]); const [apiResponse, setApiResponse] = useState()
  const [buttonClass, setButtonClass] = useState(`${props.buttonClass ? props.buttonClass : ''} btn btn-primary`)
  const [isLoader, setIsLoader] = useState(false)
  const [showEdit, setShowEdit] = useState(props.showEdit === false ? false : true);
  const [showNotify, setShowNotify] = useState(props.showNotify === false ? false : true);
  const [showChartNotes, setShowChartNotes] = useState(props.showChartNotes === false ? false : true);
  const [showCopy, setShowCopy] = useState(props.showCopy === false ? false : true);
  const [showDelete, setShowDelete] = useState(props.showDelete === false ? false : true);
  const [showStatus, setShowStatus] = useState(props.showStatus === false ? false : true);
  const [isDropDownOpen, setIsDropDownOpen] = useState(false);
  // const ellipsisStyle = {
  //   display: 'flex',
  //   justifyContent: 'center',
  //   alignItems: 'center'
  // };
  useEffect(() => {
    const items = [];
    if (!appointmentData?.parentGroupId) {
      if (showNotify && (new Date() < new Date(appointmentData?.fromDate))) {
        items.push(<Dropdown.Item key="notify" onClick={() => {setNotifyView(true); setIsDropDownOpen(false)}}>Notify</Dropdown.Item>);
      }
      if (showCopy && state.permissions.schedulingModifyAppointments) {
        items.push(<Dropdown.Item key="copy-appointment" onClick={() => {setShowAdd(true); setIsDropDownOpen(false)}}>Copy Appointment</Dropdown.Item>);
      }
      if (showChartNotes) items.push(<Dropdown.Item key="chart-notes" onClick={() => {setChartNotes(true); setIsDropDownOpen(false)}}>Chart Notes</Dropdown.Item>);
      if (showDelete) items.push(<Dropdown.Item key="cancel" onClick={() => {setDeleteView(true); setIsDropDownOpen(false)}}>Cancel/No Show</Dropdown.Item>);
    }
    setDropdownItems(items);
  }, []);

  const deleteAppointment = () => {
    setIsLoader(true)
    AppointmentService.deleteAppointment({
      id: appointmentData?.id,
      providerId: appointmentData?.providerId,
      reason: reason,
      cancelledTypeId: parseInt(cancelType) || 1
    }).then(res => {
      setApiResponse(res);
    })
      .catch(err => {
        setApiResponse(err);
      }).finally(()=>{
        setIsLoader(false)
        setDeleteView(false)
      })
  }
  const checkOut = () => {
    let reqObj = {
        ParentGroupId: appointmentData?.id,
        PracticeLocation: appointmentData?.practiceLocationId
    }
    AppointmentService.findNextAppointment(reqObj)
        .then(res => {
            let newEvent = { ...appointmentData };
            newEvent.childServices = [];

            if (res && Array.isArray(res)) {
                newEvent.childServices = res.map(appt => {
                    let newObj =
                    {
                        practiceServiceTypeId: appt.practiceServiceTypeId,
                        doctorId: appt.doctorId
                    }
                    return newObj;
                }
                );
            }
            return setCheckOutInvoice(newEvent)
        })
        .catch((err) => {
            toast.error("Patient Checked Out Failed")
        })
}

const onStatusUpdated = (selectedStatus) => {
    if (props.refresh()) {
        props.refresh()
    }
    setStatusView(false);
    if (selectedStatus.isCheckout) {
        if (appointmentData?.invoiceId) {
            if (appointmentData?.invoiceType == null || appointmentData?.invoiceType == 4 || appointmentData?.invoiceType == 0) {
                setShowEditInvoice(true);
            }
        }
        else {
            checkOut();
        }
    }
}
  const onSuccess = (message) => {
    if (props.refresh) {
      props.refresh()
    }
    if (props.onClose) {
      props.onClose()
    }
    if (props.exitHandler) {
      props.exitHandler()
    }
  }
  return (
    <>
      {showEdit ? <button className={buttonClass} onClick={e => { e.preventDefault(); setEditAppt(true) }} title="Edit">
        <i className='icon pencil' />
      </button> : null}
      {showStatus && appointmentData?.icon ? <button className={buttonClass} onClick={e => { e.preventDefault(); setStatusView(true) }} title={appointmentData?.appointmentStatusCode}>
        <i className={`icon ${appointmentData?.icon}`} />
      </button> : null}
      {props.extraButton && props.extraButton}
      {dropdownItems.length > 0 && (
        <Popup
          className="no-border-popup"
          trigger={
            <Button
              icon
              className={`${props.buttonClass ? 'btn-primary p-1 m-0' : 'btn-primary'} `}
              style={{ cursor: 'pointer',borderRadius: '0px 5px 5px 0'}}
            >
              <Icon name="ellipsis horizontal"/>
            </Button>
          }
          content={
            <Dropdown.Menu className="custom-popup-menu" closePopup={() => setIsDropDownOpen(false)}>
              {dropdownItems}
            </Dropdown.Menu>
          }
          on="click"
          position="top right"
          open={isDropDownOpen}
          onClose={() => setIsDropDownOpen(false)}
          onOpen={() => setIsDropDownOpen(true)}
        />
      )}

      {/* {dropdownItems.length > 0 && (
        <Dropdown button direction="left" icon="ellipsis horizontal" className={`${props.buttonClass ? 'btn-primary icon btn p-1 ps-0 m-0' : 'btn-primary icon btn p-o'}`} style={ellipsisStyle}>
          <Dropdown.Menu>
            {dropdownItems}
          </Dropdown.Menu>
        </Dropdown>
      )} */}
      {editAppt && (
        <ModalBox open={editAppt} onClose={() => { setEditAppt(false) }} title="Edit Appointment">
          <EditAppointmentForm id={appointmentData?.parentGroupId || appointmentData?.id} onClose={() => { setEditAppt(false); }} refresh={() => props.refresh()} buttonLabel="Update" />
        </ModalBox>
      )}

      {showAdd && (
        <ModalBox open={showAdd} onClose={() => { setShowAdd(false); }} title="Add Appointment">
          {showAdd && <AddAppointmentForm initialData={appointmentData} onClose={() => { setShowAdd(false) }} refresh={() => props.refresh()} />}
        </ModalBox>
      )}

      {chartNotes && (
        <ModalBox open={chartNotes} onClose={() => { setChartNotes(false); }} size="fullscreen" title="Chart Notes">
          <ChartNotes appointment={appointmentData} onClose={() => { setChartNotes(false); }} ></ChartNotes>
        </ModalBox>
      )}

      {notifyView && (
        <ModalBox open={notifyView} onClose={() => { setNotifyView(false) }} title="Notify">
          <AppointmentNotify onClose={() => { setNotifyView(false) }} event={appointmentData} appointmentId={appointmentData?.id} />
        </ModalBox>
      )}

      {deleteView && (
        <ModalBox open={deleteView} onClose={() => { setDeleteView(false) }} title="Cancel/No Show">
          {isLoader && <DimLoader/>}
          <span>Are you sure you want to Cancel this Appointment?</span>
          <div className='field required mt-4'>
            <label>Type of Cancellation</label>
            <select className='form-select' value={cancelType} onChange={e => { e.preventDefault(); setCancelType(e.target.value); }}>
              <option selected value={1}>Cancelled</option>
              <option value={2}>No Show</option>
            </select>
          </div>
          <div className='field required'>
            <label>Reasons</label>
            <input type="text" value={reason} onChange={e => { e.preventDefault(); setReason(e.target.value); }} />
          </div>
          <div className='d-flex justify-content-between mt-3'>
            <div className='col-auto'><button className='btn btn-primary' onClick={e => { e.preventDefault(); deleteAppointment();}}>Confirm</button></div>
            <div className='col-auto'><button className="btn btn-secondary" onClick={e => { e.preventDefault(); setDeleteView(false) }}>Close</button></div>
          </div>
        </ModalBox>
      )}
      {statusView && (<ModalBox open={statusView} title="Status" requireConfirm onClose={() => { setStatusView(false); }} size="tiny">
        <AppointmentStatus appointmentId={appointmentData?.id} appointment={appointmentData} onStatusUpdated={onStatusUpdated} onClose={() => { setStatusView(false) }}  ></AppointmentStatus>
      </ModalBox>)}
      {showEditInvoice && (<ModalBox open={showEditInvoice} onClose={() => setShowEditInvoice(false)} size="fullscreen" title="Edit Invoice">
        <EditInvoice appointmentId={appointmentData?.parentGroupId || appointmentData?.id} id={appointmentData?.invoiceId} pull={showEditInvoice} onClose={() => { setShowEditInvoice(false) }} />
      </ModalBox>)}
      {checkOutInvoice && (<ModalBox open={checkOutInvoice != null} onClose={() => { setCheckOutInvoice(null) }} size="fullscreen" title="Add Invoice">
        <AddInvoice appointmentId={appointmentData?.parentGroupId || appointmentData?.id} initialData={checkOutInvoice} onClose={() => { setCheckOutInvoice(null) }} isModal />
      </ModalBox>)}
      {apiResponse && (
        <APIResponse onClose={() => { setApiResponse() }} apiResponse={apiResponse} onSuccess={onSuccess} toastOnSuccess={true} />
      )}
    </>
  );
};

export default AppointmentButtonGroup;